export default "__VITE_ASSET__CDXQx3TA__";